module.exports = __webpack_public_path__ + "img/image_section_2.0f49d61a.png";